module.exports = __webpack_public_path__ + "ios.ad57c0.svg";